import React from "react";
import { useNavigate } from "react-router-dom";
import PaginatedTable from "../../components/PaginatedTable";

const TransactionTablePaginated = ({ transactions }) => {
  const navigate = useNavigate();

  const columns = [
    {
      field: "id",
      headerName: "#",
      minWidth: 50,
      renderCell: (params) => {
        // Simple sequential numbering for now
        // This will be improved when we have proper pagination state
        return params.row._id ? params.row._id.slice(-4) : "N/A";
      }
    },
    {
      field: "product",
      headerName: "Product",
      minWidth: 200,
      renderCell: (params) => params.value?.name || "N/A"
    },
    {
      field: "customer",
      headerName: "Customer",
      minWidth: 250,
      renderCell: (params) => {
        if (!params.value) return "N/A";
        const customer = params.value;
        return (
          <div>
            <div>{`${customer.firstName || ""} ${customer.lastName || ""}`}</div>
            <div style={{ fontSize: "0.8em", color: "#666" }}>{customer.email || ""}</div>
            <div style={{ fontSize: "0.8em", color: "#666" }}>{customer.phone || ""}</div>
          </div>
        );
      }
    },
    {
      field: "createdOnUTC",
      headerName: "Created",
      minWidth: 120,
      renderCell: (params) => new Date(params.value).toLocaleDateString()
    },
    {
      field: "partnerCompany",
      headerName: "Partner Company",
      minWidth: 200,
      renderCell: (params) => {
        if (!params.value) return "N/A";
        const company = params.value;
        return company.name || "N/A";
      }
    },
    {
      field: "partnerUser",
      headerName: "Submitted By",
      minWidth: 150,
      renderCell: (params) => {
        const partnerUser = params.value;
        const merchantUser = params.row?.merchantUser;
        const user = partnerUser || merchantUser;
        if (!user) return "N/A";
        const name = `${user.firstName || ""} ${user.lastName || ""}`.trim();
        return name || user.email || "N/A";
      }
    },
    {
      field: "invoiceStatus",
      headerName: "Invoice Status",
      minWidth: 120,
      renderCell: (params) => (
        <span
          style={{
            color: params.value === "PAID" ? "green" : "orange",
            fontWeight: "bold"
          }}
        >
          {params.value || "N/A"}
        </span>
      )
    },
    {
      field: "selfSignUp",
      headerName: "Self Sign Up",
      minWidth: 120,
      renderCell: (params) => (
        <span
          style={{
            color: params.value ? "green" : "red",
            fontWeight: "bold"
          }}
        >
          {params.value ? "Yes" : "No"}
        </span>
      )
    },
    {
      field: "price",
      headerName: "Price",
      minWidth: 100,
      renderCell: (params) => `$${params.value || 0}`
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 150,
      renderCell: (params) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <button
            onClick={() => handleRowClick(params)}
            style={{
              backgroundColor: "#1976d2",
              color: "white",
              border: "none",
              padding: "4px 12px",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "12px"
            }}
          >
            VIEW
          </button>
          <button
            onClick={() => {
              if (window.confirm("Are you sure you want to delete this transaction?")) {
                // Add delete functionality here
                console.log("Delete transaction:", params.row._id);
              }
            }}
            style={{
              backgroundColor: "#d32f2f",
              color: "white",
              border: "none",
              padding: "4px 12px",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "12px"
            }}
          >
            DELETE
          </button>
        </div>
      )
    }
  ];

  const handleRowClick = (params) => {
    navigate(`/transaction/${params.row._id}`);
  };

  const getRowClassName = (params) => {
    return !params.row.active ? "inactive-transaction-row" : "";
  };

  return (
    <PaginatedTable
      endpoint="v1/transaction"
      searchEndpoint="v1/transaction/search"
      columns={columns}
      searchFields={["customer email", "customer name", "customer phone", "product", "partnerCompany", "partnerUser"]}
      dateFields={["createdOnUTC"]}
      title="Transaction Management"
      onRowClick={handleRowClick}
      getRowClassName={getRowClassName}
      sx={{
        "& .inactive-transaction-row": {
          backgroundColor: "#fef2f2",
          "&:hover": {
            backgroundColor: "#fee2e2"
          }
        }
      }}
    />
  );
};

export default TransactionTablePaginated;
